import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { websocketActions } from '@docavenue/core';
import { get } from 'lodash';
import { useApplicationType } from '../../../src/hooks';
import config from '../../../src/config';

const Websocket = () => {
  const token = useSelector(state => get(state, 'authentication.item.token'));
  const userId = useSelector(state => get(state, 'authentication.item.id'));
  const applicationType = useApplicationType();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      websocketActions.connect('PATIENT', applicationType, {
        buildNumber: config.get('BUILD_NUMBER'),
        releaseVersion: config.get('NEXT_PUBLIC_RELEASE_VERSION'),
      }),
    );
  }, []);

  React.useEffect(() => {
    if (!token) {
      dispatch(websocketActions.logout());
    } else {
      dispatch(websocketActions.authenticate());
      dispatch(websocketActions.join(`documents_${userId}`));
    }
  }, [dispatch, token]);

  return null;
};

export default Websocket;
